export default __webpack_public_path__ + "730e57e7909cc4080cdc1c468a0029ab.png";